import {
  SET_STATUS_VALUE,
  SET_PROJECT_DETIAL_DATA,
  SET_VERSIONS,
  SET_IS_EDIT,
  SET_SUBTYPE,
} from '../actions/types';

const initialState = {
  isEdit: false,
  homeReviewStatusList: [
    { value: 0, text: 'All', showTitle: 'All My Projects' },
    { value: 1, text: 'Assigned', showTitle: 'Waiting for Acceptance' },
    { value: 2, text: 'Ready', showTitle: 'Ready Projects' },
    { value: 3, text: 'In Progress', showTitle: 'In Progress Projects' },
    { value: 4, text: 'Rejected', showTitle: 'Rejected Projects' },
    { value: 5, text: 'Completed', showTitle: 'Completed Projects' },
  ],
  statusValue: 0,

  versions: [], //版本

  tSubType: 0, // 字幕判定要不要做秒數驗算

  projectListData: [
    {
      ID: '452619',
      ProjectName: 'DinoTrux - Season 3- Slide EP.1_D-S_1_20963',
      Job: 'Sub/Text QC',
      SourceLanguage: 'EN',
      TargetLanguage: 'ZH-HANT',
      StaffinCharge: 'Sub Pro Official',
      EstStartDate: ' ',
      DueDate: '2019-10-29 22:00:00',
      Status: 'In Progress',
      Editor: '',
      Quantity: 0,
      Amount: 0,
    },
  ],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_SUBTYPE:
        return {
          ...state,
          tSubType: action.payload,
        };
    case SET_IS_EDIT:
      return {
        ...state,
        isEdit: action.payload,
      }; 
    case SET_VERSIONS:
      return {
        ...state,
        versions: action.payload,
      };

    case SET_PROJECT_DETIAL_DATA:
      return {
        ...state,
        projectListData: action.payload,
      };

    //設定選擇狀態
    case SET_STATUS_VALUE:
      return {
        ...state,
        statusValue: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ProjectReducer.js